import { Controller } from "@hotwired/stimulus";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import prefersReducedMotion from "../../utilities/prefersReducedMotion";
import enableAnimationBreakpoint from "../../utilities/enableAnimationBreakpoint";

export default class extends Controller {
  static targets = ['seal', 'outerRing'];

  connect() {
    gsap.registerPlugin(ScrollTrigger);

    const reduceMotion = prefersReducedMotion();
    const enableAnimation = enableAnimationBreakpoint();

    if (!reduceMotion && enableAnimation) {
      this.animateSeal();
    }
    else {
      this.sealTarget.classList.add('animated-seal-disabled');
    }
  }

  animateSeal() {
    gsap.to(this.outerRingTarget, {
      scrollTrigger: {
        trigger: this.outerRingTarget,
        scrub: true,
      },
      rotation: 180,
      transformOrigin: '50% 50%'
    });
  }

}